import { ChangeDetectionStrategy, Component, OnInit, signal } from '@angular/core';

const SECRET_CODE = 'braudel';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {
  showWarning = signal(true);
  codeInput = signal('');
  codeError = signal(false);

  ngOnInit(): void {
    const savedCode = localStorage.getItem('savedCode');
    if (savedCode === SECRET_CODE) {
      this.showWarning.set(false);
    }
  }

  onCodeInput(value: string): void {
    this.codeInput.set(value);
    this.codeError.set(false);
  }

  submitCode(): void {
    if (this.codeInput().toLowerCase() === SECRET_CODE) {
      this.showWarning.set(false);
      localStorage.setItem('savedCode', this.codeInput());
    } else {
      this.codeError.set(true);
    }
  }

  onKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.submitCode();
    }
  }
}
